@if (links$ | async; as links) {
    @if (links$ | async; as links) {
        @for (item of links; track $index) {
            @if (!isMobileMenuOpen) {
                <button
                    type="button"
                    class="h-full flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700 h-11"
                    (click)="download(item)">
                    <div class="mr-0.5 hidden xl:block">{{ item.text }}</div>
                    <je-fa-icon [name]="'download'" class="mt-0.5"></je-fa-icon>
                </button>
            } @else {
                <button type="button" class="flex flex-row items-center py-3 px-2 border-0 border-b border-solid border-black-200 h-11" (click)="download(item)">
                    <je-fa-icon [name]="'download'"></je-fa-icon>
                    <div class="ml-0.5">{{ item.text }}</div>
                </button>
            }
        }
    }
}
